---
title: "I criticized Musk's leadership seven years ago - nothing has changed"
slug: "criticized-musks-leadership-seven-years-ago"
date: "2025-06-04"
excerpt: "From the Thai cave rescue to the Department of Governmental Efficiency: Why Elon Musk's 'hero engineer' leadership style consistently fails in complex human crises."
metaTitle: "Musk's Leadership: Seven Years Later | Kevin Rassner"
metaDescription: "Analyzing Elon Musk's leadership style from the Thai cave rescue to the Department of Governmental Efficiency. Has his approach evolved? The evidence suggests not."
language: "en"
author: "Kevin Rassner"
authorUrl: "https://rassner-dev.org"
linkedinUrl: "https://www.linkedin.com/feed/update/urn:li:activity:7336017044347256832"
isLinkedInPost: true
---

In 2018, I wrote a LinkedIn article examining Elon Musk's leadership failures during catastrophic times (specifically the Thai cave rescue). Looking back at his gig to consult/lead the Department of Governmental Efficiency under Trump, I'm struck by how little has evolved in his approach.

The core pattern remains identical:
1. Insert yourself as the primary hero in a complex crisis
2. Propose a technically "brilliant" but contextually flawed solution (the mini-sub then, mass firings now)
3. Attack anyone who points out the contextual reality (the cave diver then, civil servants now)
4. Claim victimhood when the "simple" solution fails against complex reality

What's fascinating isn't just the repetition, but the scaling. We've moved from a cave rescue to national governance, but the leadership algorithm hasn't updated. It's still "Engineer vs. Reality," with no appreciation for the human and systemic nuance that actually solves crises.

Seven years later, the lesson remains: Brilliance without empathy isn't leadership - it's just high-stakes engineering with people as collateral damage.

You can find the original article here: https://lnkd.in/e_f-X-t

